import type { ChatMessage } from "./types.ts";
import { stripRuntimeContextText } from "./ai/request-context.ts";

export function getTextFromMessage(message: ChatMessage): string {
	return message.parts
		.filter((part) => part.type === "text")
		.map((part) => stripRuntimeContextText(part.text))
		.filter((text) => text.length > 0)
		.join("");
}
